import {useMemo} from 'react';

const useProcedureDirtyCheck = (procedure, originalSnapshot, name, desc, ai, settings, threeDSettings, roles, models, allowRun, speed) => {
    return useMemo(() => {
        if (!originalSnapshot) return false;
        return name !== (originalSnapshot.ProcedureName || '')
            || desc !== (originalSnapshot.ProcedureDescription || '')
            || ai !== (originalSnapshot.AIInstructions || '')
            || JSON.stringify(settings) !== JSON.stringify(originalSnapshot.Settings || {})
            || JSON.stringify(threeDSettings) !== JSON.stringify(originalSnapshot.ThreeDSettings || {})
            || JSON.stringify(roles) !== JSON.stringify(originalSnapshot.PermittedTrainingAndFieldRoles || {})
            || JSON.stringify(models) !== JSON.stringify(originalSnapshot.ThreeDModelsConnected || [])
            || allowRun !== (originalSnapshot.AllowRun || null)
            || speed !== (originalSnapshot.Settings?.CameraMovementSpeedBetweenStep || 0)
            || (procedure?.coverImg || '') !== (originalSnapshot.coverImg || '')
            || (procedure?.coverImgThumb || '') !== (originalSnapshot.coverImgThumb || '');
    }, [procedure, originalSnapshot, name, desc, ai, settings, threeDSettings, roles, models, allowRun, speed]);
};

export default useProcedureDirtyCheck;
